import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import TextArea from "../../../../../components/form/TextArea";

export default function CustomBrandPersonaVoiceToneInput() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <TextArea
      label=""
      name="customBrandPersonaVoiceTone"
      value={values?.customBrandPersonaVoiceTone ?? ""}
      tooltip="Describe specific brand persona, voice, and tone requirements."
      placeholder="example: Write as a knowledgeable financial advisor, in a direct and plainspoken voice, with a calm, evidence-first, reassuring tone."
      maxLength={10000}
      maxHeight={400}
      showCharacterCount={true}
      onChange={({ target: { value } }) =>
        setFieldValue("customBrandPersonaVoiceTone", value)
      }
      onBlur={({ target: { value } }) => {
        setFieldValue("customBrandPersonaVoiceTone", value.trim());
      }}
    />
  );
}
